
export default function Features() {
  const features = [
    {
      icon: 'ri-lock-line',
      title: 'End-to-End Encryption',
      description: 'Military-grade encryption protocols ensure your data remains completely secure and private at all times during transmission and storage.'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Fast Connection Speed',
      description: 'Experience blazing-fast performance with optimized servers worldwide, ensuring seamless browsing and streaming without delays.'
    },
    {
      icon: 'ri-brush-line',
      title: 'Smart Cleaning',
      description: 'Intelligent algorithms identify and remove unnecessary files, cache, and temporary data to free up valuable storage space.'
    },
    {
      icon: 'ri-folder-line',
      title: 'Storage Optimization',
      description: 'Advanced storage management tools help you organize and optimize your device storage for maximum efficiency and performance.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Privacy Protection',
      description: 'Comprehensive privacy features safeguard your personal information and online activities from trackers and malicious threats.'
    },
    {
      icon: 'ri-user-smile-line',
      title: 'User-Friendly Interface',
      description: 'Intuitive design and seamless navigation make our applications easy to use for everyone, regardless of technical expertise.'
    }
  ];

  return (
    <section id="features" className="bg-[#f9fafb] py-32 px-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-24">
          <div className="inline-block px-6 py-2 rounded-full border-2 border-[#1a1f36] mb-6">
            <span className="text-sm text-[#1a1f36] font-medium">Key Features</span>
          </div>
          <h2 className="text-5xl font-bold text-[#1a1f36] mb-6 leading-tight">
            Powerful Features<br />Built for Excellence
          </h2>
          <p className="text-lg text-[#6b7280] max-w-2xl mx-auto">
            Every feature is carefully crafted to deliver exceptional performance and user experience
          </p>
        </div>

        <div className="grid grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-sm hover:bg-[#e0f2fe] hover:shadow-lg transition-all duration-300 cursor-pointer group"
            >
              <div className="w-16 h-16 rounded-full bg-[#f3f4f6] flex items-center justify-center mb-6 group-hover:bg-white transition-colors duration-300">
                <i className={`${feature.icon} text-[#1a1f36] text-3xl`}></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1a1f36] mb-4 leading-snug">
                {feature.title}
              </h3>
              <p className="text-[#6b7280] text-base leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
